import api from './api';

export async function register(data) {
	const res = await api.post('/auth/register', data);
	return res.data;
}

export async function login(email, password) {
	const res = await api.post('/auth/login', { email, password });
	return res.data;
}

export async function verifyEmail(token) {
	const res = await api.get(`/auth/verify-email/${token}`);
	return res.data;
}

export async function forgotPassword(email) {
	const res = await api.post('/auth/forgot-password', { email });
	return res.data;
}

export async function resetPassword(token, password) {
	const res = await api.put(`/auth/reset-password/${token}`, { password });
	return res.data;
}

export async function getProfile() {
	const res = await api.get('/auth/profile');
	return res.data;
}

export async function updateProfile(data) {
	const res = await api.put('/auth/profile', data);
	return res.data;
}

export async function applyReferral(code) {
	const res = await api.post('/auth/apply-referral', { referralCode: code });
	return res.data;
}


